import { render, staticRenderFns } from "./M_file.vue?vue&type=template&id=2ab1754a&scoped=true&"
import script from "./M_file.vue?vue&type=script&lang=js&"
export * from "./M_file.vue?vue&type=script&lang=js&"
import style0 from "./M_file.vue?vue&type=style&index=0&id=2ab1754a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab1754a",
  null
  
)

export default component.exports